import dynamic from 'next/dynamic';
import { FunctionComponent, SyntheticEvent } from 'react';
import { IIconProps } from '@bridebook/ui/src/types';
import { FelaCSS } from '../components/fela/flowtypes';
import { IStylingProps, TColor } from '../themes/types';

export interface IconProps extends IStylingProps {
  id?: string;
  color?: TColor;
  color2?: TColor;
  backgroundColor?: string;
  width?: number;
  height?: number;
  style?: FelaCSS;
  onClick?(e: SyntheticEvent<SVGElement>): void;
  fillOpacity?: number;
}

/* ############################################################################
 *  EXPORTS
 * ######################################################################### */

export type IconComp = FunctionComponent<IconProps>;

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconApprove = dynamic<IconProps>(() => import('../components/svg/icon-approve'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconGiftlist = dynamic<IconProps>(() => import('../components/svg/icon-giftlist'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconArrow = dynamic<IconProps>(() => import('../components/svg/icon-arrow'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconAwardCup = dynamic<IconProps>(() => import('../components/svg/icon-award-cup'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconAwardQuote = dynamic<IconProps>(
  () => import('../components/svg/icon-award-quote'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconAwardBadge = dynamic<IconProps>(
  () => import('../components/svg/icon-award-badge'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBb = dynamic<IconProps>(() => import('../components/svg/icon-bb'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconAccommodation = dynamic<IconProps>(
  () => import('../components/svg/icon-accommodation'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBookFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-book-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBook = dynamic<IconProps>(() => import('../components/svg/icon-book'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBookmark = dynamic<IIconProps>(() => import('../components/svg/icon-bookmark'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBookmarkFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-bookmark-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBudget = dynamic<IconProps>(() => import('../components/svg/icon-budget'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBurger = dynamic<IconProps>(() => import('../components/svg/icon-burger'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBurgerCircled = dynamic<IconProps>(
  () => import('../components/svg/icon-burger-circled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCalendar = dynamic<IIconProps>(() => import('../components/svg/icon-calendar'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCalendarHeart = dynamic<IIconProps>(
  () => import('../components/svg/icon-calendar-heart'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconChecklist = dynamic<IconProps>(() => import('../components/svg/icon-checklist'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconChecklistFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-checklist-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconChevron = dynamic<IIconProps>(() => import('../components/svg/icon-chevron'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCross = dynamic<IconProps>(() => import('../components/svg/icon-cross'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCrossBold = dynamic<IconProps>(() => import('../components/svg/icon-cross-bold'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconExternalLink = dynamic<IconProps>(
  () => import('../components/svg/icon-external-link'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconExclusiveUse = dynamic<IconProps>(
  () => import('../components/svg/icon-exclusive-use'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconContact = dynamic<IconProps>(() => import('../components/svg/icon-contact'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconArchive = dynamic<IconProps>(() => import('../components/svg/icon-archive'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconUnarchive = dynamic<IconProps>(() => import('../components/svg/icon-unarchive'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconHoneymoon = dynamic<IconProps>(() => import('../components/svg/icon-honeymoon'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconExperience = dynamic<IconProps>(
  () => import('../components/svg/icon-experience'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconFacebook = dynamic<IconProps>(() => import('../components/svg/icon-facebook'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconGuest = dynamic<IconProps>(() => import('../components/svg/icon-guest'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconGuestSingle = dynamic<IconProps>(
  () => import('../components/svg/icon-guest-single'),
  {
    loading: () => null,
    ssr: false,
  },
);
/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconHomeDashboard = dynamic<IconProps>(
  () => import('../components/svg/icon-home-dashboard'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 */
/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconHome = dynamic<IconProps>(() => import('../components/svg/icon-home'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconHomeMain = dynamic<IconProps>(() => import('../components/svg/icon-home-main'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconHomeFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-home-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconWeddingLicence = dynamic<IconProps>(
  () => import('../components/svg/icon-wedding-licence'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconInstagram = dynamic<IconProps>(() => import('../components/svg/icon-instagram'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconWeb = dynamic<IconProps>(() => import('../components/svg/icon-web'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLetter = dynamic<IconProps>(() => import('../components/svg/icon-letter'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLinkedin = dynamic<IconProps>(() => import('../components/svg/icon-linkedin'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLocation = dynamic<IconProps>(() => import('../components/svg/icon-location'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLocationFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-location-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLock = dynamic<IconProps>(() => import('../components/svg/icon-lock'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLogout = dynamic<IconProps>(() => import('../components/svg/icon-logout'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLoveLetter = dynamic<IconProps>(
  () => import('../components/svg/icon-love-letter'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLoveLetterBold = dynamic<IconProps>(
  () => import('../components/svg/icon-love-letter-bold'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconNote = dynamic<IconProps>(() => import('../components/svg/icon-note'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconPackage = dynamic<IconProps>(() => import('../components/svg/icon-package'), {
  loading: () => null,
  ssr: false,
});

/** @deprecated - use `Send` icon from aura design system */
/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconPaperplane = dynamic<IconProps>(
  () => import('../components/svg/icon-paperplane'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconEdit = dynamic<IconProps>(() => import('../components/svg/icon-edit'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconPhone = dynamic<IconProps>(() => import('../components/svg/icon-phone'), {
  loading: () => null,
  ssr: false,
});

export const IconPhotoV2 = dynamic<IconProps>(() => import('../components/svg/icon-photo-v2'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCamera = dynamic<IconProps>(() => import('../components/svg/icon-camera'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCards = dynamic<IconProps>(() => import('../components/svg/icon-cards'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconImg = dynamic<IconProps>(() => import('../components/svg/icon-img'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconPound = dynamic<IconProps>(() => import('../components/svg/icon-pound'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconRing = dynamic<IconProps>(() => import('../components/svg/icon-ring'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSearch = dynamic<IconProps>(() => import('../components/svg/icon-search'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSearchHeart = dynamic<IconProps>(
  () => import('../components/svg/icon-search-heart'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSearchHeartThin = dynamic<IconProps>(
  () => import('../components/svg/icon-search-heart-thin'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSearchWrong = dynamic<IconProps>(
  () => import('../components/svg/icon-search-wrong'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 */
/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSettingDeprecated = dynamic<IconProps>(
  () => import('../components/svg/icon-setting-deprecated'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSettingFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-setting-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconReview = dynamic<IconProps>(() => import('../components/svg/icon-review'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconReviewFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-review-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconTestimonials = dynamic<IconProps>(
  () => import('../components/svg/icon-testimonials'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconTick = dynamic<IconProps>(() => import('../components/svg/icon-tick'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconTickBold = dynamic<IconProps>(() => import('../components/svg/icon-tick-bold'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconTickRound = dynamic<IconProps>(() => import('../components/svg/icon-tick-round'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconTwitter = dynamic<IconProps>(() => import('../components/svg/icon-twitter'), {
  loading: () => null,
  ssr: false,
});

/** @deprecated - use `Venue` icon from aura design system */
/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconVenue = dynamic<IconProps>(() => import('../components/svg/icon-venue'), {
  loading: () => null,
  ssr: false,
});

export const IconVenueColorful = dynamic<IconProps>(
  () => import('../components/svg/icon-venue-colorful'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconVimeo = dynamic<IconProps>(() => import('../components/svg/icon-vimeo'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconVideo = dynamic<IconProps>(() => import('../components/svg/icon-video'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconWeddingPlanningTools = dynamic<IconProps>(
  () => import('../components/svg/icon-wedding-planning-tools'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconWeddingDate = dynamic<IconProps>(
  () => import('../components/svg/icon-wedding-date'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconFilter = dynamic<IconProps>(() => import('../components/svg/icon-filter'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconAdd = dynamic<IIconProps>(() => import('../components/svg/icon-add'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconAllFilters = dynamic<IconProps>(
  () => import('../components/svg/icon-all-filters'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconPlay = dynamic<IconProps>(() => import('../components/svg/icon-play'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconPhotographer = dynamic<IconProps>(
  () => import('../components/svg/icon-photographer'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconWarningFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-warning-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconWarning = dynamic<IconProps>(() => import('../components/svg/icon-warning'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconWelcome = dynamic<IconProps>(() => import('../components/svg/icon-welcome'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconConfeti = dynamic<IconProps>(() => import('../components/svg/icon-confeti'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconRepeat = dynamic<IconProps>(() => import('../components/svg/icon-repeat'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconAutumn = dynamic<IconProps>(() => import('../components/svg/icon-autumn'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconWinter = dynamic<IconProps>(() => import('../components/svg/icon-winter'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSpring = dynamic<IconProps>(() => import('../components/svg/icon-spring'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconTrash = dynamic<IIconProps>(() => import('../components/svg/icon-trash'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconQuick = dynamic<IIconProps>(() => import('../components/svg/icon-quick'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconWeddingAdditional = dynamic<IconProps>(
  () => import('../components/svg/icon-wedding-additional'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSummer = dynamic<IconProps>(() => import('../components/svg/icon-summer'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconQuestionMark = dynamic<IconProps>(
  () => import('../components/svg/icon-question-mark'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCoplanners = dynamic<IIconProps>(
  () => import('../components/svg/icon-coplanners'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconEvening = dynamic<IconProps>(() => import('../components/svg/icon-evening'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconToasting = dynamic<IconProps>(() => import('../components/svg/icon-toasting'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconEmail = dynamic<IconProps>(() => import('../components/svg/icon-email'), {
  loading: () => null,
  ssr: false,
});

export const IconGoogleColor = dynamic<IconProps>(
  () => import('../components/svg/icon-google-color'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconChat = dynamic<IconProps>(() => import('../components/svg/icon-chat'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 */
/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconInbox = dynamic<IconProps>(() => import('../components/svg/icon-inbox'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconPinterest = dynamic<IconProps>(() => import('../components/svg/icon-pinterest'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLink = dynamic<IconProps>(() => import('../components/svg/icon-link'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCopy = dynamic<IconProps>(() => import('../components/svg/icon-copy'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconApple = dynamic<IconProps>(() => import('../components/svg/icon-apple'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconPlaystore = dynamic<IconProps>(() => import('../components/svg/icon-playstore'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconAddCircle = dynamic<IconProps>(() => import('../components/svg/icon-add-circle'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSearchFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-search-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSearchHeartFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-search-heart-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconGuestFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-guest-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBudgetFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-budget-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconClock = dynamic<IconProps>(() => import('../components/svg/icon-clock'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconDress = dynamic<IconProps>(() => import('../components/svg/icon-dress'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBeauty = dynamic<IconProps>(() => import('../components/svg/icon-beauty'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconMusic = dynamic<IconProps>(() => import('../components/svg/icon-music'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCake = dynamic<IconProps>(() => import('../components/svg/icon-cake'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconMenswear = dynamic<IconProps>(() => import('../components/svg/icon-menswear'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconOther = dynamic<IconProps>(() => import('../components/svg/icon-other'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconMarquee = dynamic<IconProps>(() => import('../components/svg/icon-marquee'), {
  loading: () => null,
  ssr: false,
});

export const IconSupplierMarquee = dynamic<IconProps>(
  () => import('../components/svg/icon-supplier-marquee'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconExport = dynamic<IconProps>(() => import('../components/svg/icon-export'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconScrapbook = dynamic<IconProps>(() => import('../components/svg/icon-scrapbook'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconScrapbookFilled = dynamic<IconProps>(
  () => import('../components/svg/icon-scrapbook-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/* ############################################################################
 *  UNCONFIRMED
 * ######################################################################### */

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const BridebookLogo = dynamic<IconProps>(() => import('../components/svg/bridebook-logo'), {
  loading: () => null,
  ssr: false,
});

export const BudgetIconCopy = dynamic<IconProps>(
  () => import('../components/svg/budget-icon-copy'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const BudgetIcon = dynamic<IconProps>(() => import('../components/svg/budget-icon'), {
  loading: () => null,
  ssr: false,
});

export const ChecklistIconCopy = dynamic<IconProps>(
  () => import('../components/svg/checklist-icon-copy'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const ChecklistIcon = dynamic<IconProps>(() => import('../components/svg/checklist-icon'), {
  loading: () => null,
  ssr: false,
});

export const GuestlistIconCopy = dynamic<IconProps>(
  () => import('../components/svg/guestlist-icon-copy'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const GuestlistIcon = dynamic<IconProps>(() => import('../components/svg/guestlist-icon'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCameraTripod = dynamic<IconProps>(
  () => import('../components/svg/icon-camera-tripod'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCarouselLeft = dynamic<IconProps>(
  () => import('../components/svg/icon-carousel-left'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCarouselRight = dynamic<IconProps>(
  () => import('../components/svg/icon-carousel-right'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCastle = dynamic<IconProps>(() => import('../components/svg/icon-castle'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconChevronFat = dynamic<IconProps>(
  () => import('../components/svg/icon-chevron-fat'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconChevronRight = dynamic<IconProps>(
  () => import('../components/svg/icon-chevron-right'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconConfirmation = dynamic<IconProps>(
  () => import('../components/svg/icon-confirmation'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconFlowers = dynamic<IconProps>(() => import('../components/svg/icon-flowers'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLocationMarker = dynamic<IconProps>(
  () => import('../components/svg/icon-location-marker'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconMagGlass = dynamic<IconProps>(() => import('../components/svg/icon-mag-glass'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSwipe = dynamic<IconProps>(() => import('../components/svg/icon-swipe'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const MacaroniRaysLeft = dynamic<IconProps>(
  () => import('../components/svg/macaroni-rays-left'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const MacaroniRaysRight = dynamic<IconProps>(
  () => import('../components/svg/macaroni-rays-right'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const VacationIcon = dynamic<IconProps>(() => import('../components/svg/vacation-icon'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBookmarkFlag = dynamic<IconProps>(
  () => import('../components/svg/icon-bookmark-flag'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconScrapbookEmpty = dynamic<IconProps>(
  () => import('../components/svg/icon-scrapbook-empty'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconQuote = dynamic<IconProps>(() => import('../components/svg/icon-quote'), {
  loading: () => null,
  ssr: false,
});

export const PremiumRocket = dynamic<IconProps>(() => import('../components/svg/premium-rocket'), {
  loading: () => null,
  ssr: false,
});

export const IconFavouritesSearch = dynamic<IconProps>(
  () => import('../components/svg/icon-favourites-search'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconKiosk = dynamic<IconProps>(() => import('../components/svg/icon-kiosk'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconDownload = dynamic<IconProps>(() => import('../components/svg/icon-download'), {
  loading: () => null,
  ssr: false,
});

export const IconBbLogoSquared = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-bb-logo-squared'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLocationShortlist = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-location-shortlist'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconMagnifier = dynamic<IconProps>(() => import('../components/svg/magnifier'), {
  loading: () => null,
  ssr: false,
});

export const IconTip = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-tip'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconEye = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-eye'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLockClosed = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-lock-closed'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLockClosedFilled = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-lock-closed-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLockOpened = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-lock-opened'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLockOpenedFilled = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-lock-opened-filled'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconVideoTour = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-video-tour'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconVectorUp = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-vector-up'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconArrowUp = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-arrow-up'),
  { loading: () => null, ssr: false },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconArrowDown = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-arrow-down'),
  { loading: () => null, ssr: false },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconVectorDown = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-vector-down'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconWeddingsIllustration = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-weddings-illustration'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconShowcaseIllustration = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-showcase-illustration'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCouplesIllustration = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-couples-illustration'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSeoIllustration = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-seo-illustration'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconEnquiriesIllustration = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-enquiries-illustration'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconUpload = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-upload'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSupplierList = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-supplier-list'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconMap = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-map'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconPremiumCrown = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-premium-crown'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconEur = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-eur'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconUsd = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-usd'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconArrowStat = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-arrow-stat'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconList = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-list'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconEnquiryEdit = dynamic<IconProps>(
  () => import('../components/svg/icon-enquiry-edit'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconReviewReply = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-review-reply'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSuppliers = dynamic<IconProps>(() => import('../components/svg/icon-suppliers'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconPlanning = dynamic<IconProps>(() => import('../components/svg/icon-planning'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSettings = dynamic<IconProps>(() => import('../components/svg/icon-settings'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconMessages = dynamic<IconProps>(() => import('../components/svg/icon-messages'), {
  loading: () => null,
  ssr: false,
});

export const SwirlChecklist = dynamic<Omit<IconProps, 'width'> & { width?: number | '100%' }>(
  () => import('../components/svg/swirl-checklist'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlScrapbook = dynamic<Omit<IconProps, 'width'> & { width?: number | '100%' }>(
  () => import('../components/svg/swirl-scrapbook'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlBudget = dynamic<Omit<IconProps, 'width'> & { width?: number | '100%' }>(
  () => import('../components/svg/swirl-budget'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlBooked = dynamic<Omit<IconProps, 'width'> & { width?: number | '100%' }>(
  () => import('../components/svg/swirl-booked'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlFavourites = dynamic<Omit<IconProps, 'width'> & { width?: number | '100%' }>(
  () => import('../components/svg/swirl-favourites'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlGuestlist = dynamic<Omit<IconProps, 'width'> & { width?: number | '100%' }>(
  () => import('../components/svg/swirl-guestlist'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlHome = dynamic<Omit<IconProps, 'width'> & { width?: number | '100%' }>(
  () => import('../components/svg/swirl-home'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlAdvice = dynamic<Omit<IconProps, 'width'> & { width?: number | '100%' }>(
  () => import('../components/svg/swirl-advice'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlAboutMe = dynamic<Omit<IconProps, 'width'> & { width?: number | '100%' }>(
  () => import('../components/svg/swirl-about-me'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlIntroSwiping = dynamic<IconProps>(
  () => import('../components/svg/swirl-intro-swiping'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const SwirlPriceEstimate = dynamic<Omit<IconProps, 'width'> & { width?: number | '100%' }>(
  () => import('../components/svg/swirl-price-estimate'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlSocialProof = dynamic<Omit<IconProps, 'width'> & { width?: number | '100%' }>(
  () => import('../components/svg/swirl-social-proof'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlStoryCard = dynamic<IconProps>(
  () => import('../components/svg/swirl-story-card'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlReview = dynamic<IconProps>(() => import('../components/svg/swirl-review'), {
  loading: () => null,
  ssr: false,
});

export const SwirlToolWidget = dynamic<Omit<IconProps, 'width'> & { width?: number | '100%' }>(
  () => import('../components/svg/swirl-tool-widget'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlWeddingWebsitePart1 = dynamic<IconProps>(
  () => import('../components/svg/swirl-wedding-website-part1'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const SwirlWeddingWebsitePart2 = dynamic<IconProps>(
  () => import('../components/svg/swirl-wedding-website-part2'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const ProgressBarMarker = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/progress-bar-marker'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const Tick = dynamic<IIconProps>(() => import('@bridebook/ui/src/components/svg/tick'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconInfoCircle = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-info-circle'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconInfoQuestionMark = dynamic<IconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-info-question-mark'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconQuiz = dynamic<IconProps>(() => import('../components/svg/icon-quiz'), {
  loading: () => null,
  ssr: false,
});

export const IconCameraColors = dynamic<IconProps>(
  () => import('../components/svg/icon-camera-colors'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSuccess = dynamic<IconProps>(() => import('../components/svg/icon-success'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconFailure = dynamic<IconProps>(() => import('../components/svg/icon-failure'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconTranslations = dynamic<IIconProps>(
  () => import('../components/svg/icon-translations'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconMail = dynamic<IIconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-mail'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconMailOpened = dynamic<IIconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-mail-opened'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconTasks = dynamic<IIconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-tasks'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCatering = dynamic<IIconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-catering'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBreakfast = dynamic<IIconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-breakfast'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconChart = dynamic<IIconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-chart'),
  {
    loading: () => null,
    ssr: false,
  },
);

/** @deprecated - use `Venue` icon from aura design system */
/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconVenue2 = dynamic<IIconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-venue-2'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconKnowledge = dynamic<IIconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-knowledge'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconHelp = dynamic<IIconProps>(
  () => import('@bridebook/ui/src/components/svg/icon-help'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconStar = dynamic<IconProps>(() => import('../components/svg/icon-star'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconInformation = dynamic<IconProps>(
  () => import('../components/svg/icon-information'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconHeartHand = dynamic<IconProps>(() => import('../components/svg/icon-heart-hand'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconBedHeart = dynamic<IconProps>(() => import('../components/svg/icon-bed-heart'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconProfileList = dynamic<IconProps>(
  () => import('../components/svg/icon-profile-list'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconProfileScoreStarter = dynamic<IconProps>(
  () => import('../components/svg/icon-profile-score-starter'),
  {
    loading: () => null,
    ssr: false,
  },
);
export const IconProfileScoreIntermediate = dynamic<IconProps>(
  () => import('../components/svg/icon-profile-score-intermediate'),
  {
    loading: () => null,
    ssr: false,
  },
);
export const IconProfileScoreAdvanced = dynamic<IconProps>(
  () => import('../components/svg/icon-profile-score-advanced'),
  {
    loading: () => null,
    ssr: false,
  },
);
export const IconProfileScoreAllStars = dynamic<IconProps>(
  () => import('../components/svg/icon-profile-score-allstars'),
  {
    loading: () => null,
    ssr: false,
  },
);
export const IconNoMessages = dynamic<IconProps>(
  () => import('../components/svg/icon-no-messages'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSupplierVideographer = dynamic<IconProps>(
  () => import('../components/svg/icon-supplier-videographer'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconVows = dynamic<IconProps>(() => import('../components/svg/icon-vows'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLockNew = dynamic<IconProps>(() => import('../components/svg/icon-lock-new'), {
  loading: () => null,
  ssr: false,
});

export const IconSupplierPlanner = dynamic<IconProps>(
  () => import('../components/svg/icon-supplier-planner'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSmartPhone = dynamic<IconProps>(
  () => import('../components/svg/icon-smart-phone'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconDescription = dynamic<IconProps>(
  () => import('../components/svg/icon-description'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconChatHeart = dynamic<IconProps>(() => import('../components/svg/icon-chat-heart'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconStarNew = dynamic<IconProps>(() => import('../components/svg/icon-star-new'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconChatQuestion = dynamic<IconProps>(
  () => import('../components/svg/icon-chat-question'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconCalendarColors = dynamic<IconProps>(
  () => import('../components/svg/icon-calendar-circle'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconPowerMatch = dynamic<IconProps>(
  () => import('../components/svg/icon-power-match'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconEventAndFairs = dynamic<IconProps>(
  () => import('../components/svg/icon-events-and-fairs'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconBoostVisibilityClassic = dynamic<IconProps>(
  () => import('../components/svg/icon-boost-visibility-classic'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconBoostVisibilityExpert = dynamic<IconProps>(
  () => import('../components/svg/icon-boost-visibility-expert'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconSpecialOffers = dynamic<IconProps>(
  () => import('../components/svg/icon-special-offers'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconInsight = dynamic<IconProps>(() => import('../components/svg/icon-insight'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconWeddingBell = dynamic<IconProps>(
  () => import('../components/svg/icon-wedding-bell'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconMessageTemplates = dynamic<IconProps>(
  () => import('../components/svg/icon-message-templates'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconScrollUp = dynamic<IconProps>(() => import('../components/svg/icon-scroll-up'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSwipeRight = dynamic<IconProps>(
  () => import('../components/svg/icon-swipe-right'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconSwipeLeft = dynamic<IconProps>(() => import('../components/svg/icon-swipe-left'), {
  loading: () => null,
  ssr: false,
});

export const IconTapLeft = dynamic<IconProps>(() => import('../components/svg/icon-tap-left'), {
  loading: () => null,
  ssr: false,
});

export const IconCursorPointerRightHand = dynamic<IconProps>(
  () => import('../components/svg/icon-cursor-pointer-right-hand'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconCursorPointerLeftHand = dynamic<IconProps>(
  () => import('../components/svg/icon-cursor-pointer-left-hand'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconLockClosedColors = dynamic<IconProps>(
  () => import('../components/svg/icon-lock-closed-colors'),
  { ssr: false },
);

export const IconHoldingHandsColors = dynamic<IconProps>(
  () => import('../components/svg/icon-holding-hands-colors'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconHelpQuestionMark = dynamic<IconProps>(
  () => import('../components/svg/icon-help-question-mark'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconNoSearchRanking = dynamic<IconProps>(
  () => import('../components/svg/icon-no-search-ranking'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLadder = dynamic<IconProps>(() => import('../components/svg/icon-ladder'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconGraphArrow = dynamic<IconProps>(
  () => import('../components/svg/icon-graph-arrow'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconReviewV2 = dynamic<IconProps>(() => import('../components/svg/icon-review-v2'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCouple = dynamic<IconProps>(() => import('../components/svg/icon-couple'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconReplied = dynamic<IconProps>(() => import('../components/svg/icon-replied'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconNotReplied = dynamic<IconProps>(
  () => import('../components/svg/icon-not-replied'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconWeddingRing = dynamic<IconProps>(
  () => import('../components/svg/icon-wedding-ring'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconStages = dynamic<IconProps>(() => import('../components/svg/icon-stages'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconTable = dynamic<IconProps>(() => import('../components/svg/icon-table'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconClose = dynamic<IconProps>(() => import('../components/svg/icon-close'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconStageCalendar = dynamic<IconProps>(
  () => import('../components/svg/icon-stages-calendar'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconOnlineDating = dynamic<IconProps>(
  () => import('../components/svg/icon-online-dating'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconStageGuests = dynamic<IconProps>(
  () => import('../components/svg/icon-stages-guests'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconStageClock = dynamic<IconProps>(
  () => import('../components/svg/icon-stages-clock'),
  {
    loading: () => null,
    ssr: false,
  },
);

export const IconNoLeads = dynamic<IconProps>(() => import('../components/svg/icon-no-leads'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconPlanner = dynamic<IconProps>(() => import('../components/svg/icon-planner'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconDoubleHeart = dynamic<IconProps>(
  () => import('../components/svg/icon-double-heart'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconCalendarHeartV2 = dynamic<IconProps>(
  () => import('../components/svg/icon-calendar-heart-v2'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconToastingV2 = dynamic<IconProps>(
  () => import('../components/svg/icon-toasting-v2'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconGift = dynamic<IconProps>(() => import('../components/svg/icon-gift'), {
  loading: () => null,
  ssr: false,
});

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconExpandView = dynamic<IconProps>(
  () => import('../components/svg/icon-expand-view'),
  {
    loading: () => null,
    ssr: false,
  },
);

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
export const IconLabel = dynamic<IconProps>(() => import('../components/svg/icon-label'), {
  loading: () => null,
  ssr: false,
});

export const IconShowroundBooked = dynamic<IconProps>(
  () => import('../components/svg/icon-showround-booked'),
  {
    loading: () => null,
    ssr: false,
  },
);
